import { NgModule, SkipSelf, Optional } from '@angular/core';

import { RestApiService } from '@services/rest-api/rest-api.service';

import { CartDataService, OffersDataService } from './api';

const APIS = [CartDataService, OffersDataService];

@NgModule({
  providers: [RestApiService, ...APIS],
  exports: [],
})
export class DataModule {
  constructor(@Optional() @SkipSelf() parentModule: DataModule) {
    if (parentModule) {
      throw new Error('DataModule is already loaded');
    }
  }
}
